export const ru = {
    title: 'Выбрать попутчика',
    description: 'Ссылка для оплаты будет отправлена в чат поддержки после оформления всех услуг',
    add_service_error_message: 'Не удалось добавить услугу',
    companion_add: 'Добавить попутчика',
    title_empty: 'В командировку вместе с близкими',
    description_empty: 'Соберём все услуги и бронирования в одном месте для удобного планирования поездок для вас и ваших близких.',
    add_later: 'Может быть позже',
};
